export default "__VITE_ASSET__DdQU60SR__"